import { render, staticRenderFns } from "./BePaymentMethod.vue?vue&type=template&id=35c04e26&scoped=true"
import script from "./BePaymentMethod.vue?vue&type=script&lang=js"
export * from "./BePaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./BePaymentMethod.vue?vue&type=style&index=0&id=35c04e26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c04e26",
  null
  
)

export default component.exports